import CustomButton from "@/components/elements/custom-button";
import AppContext from "@/contexts/appctx/app-context";
import MessageContext from "@/contexts/message-handler/message-context";
import { initializeApollo } from "@/lib/apollo";
import { BUY_SEED_MUTATION } from "@/lib/graphql/seed-sale";
import * as Timeline from "@/seed/constants/timeline";
import PoolContext from "@/seed/contexts/pool/pool-context";
import { data as tokenSaleConfig } from "@/seed/shared/token/token-sale";
import { getAllocationInfo } from "@/seed/utils/sale-info";
import { data as popupLayoutConfig } from "@/shared/popup-msg-sample";
import { formatBalance } from "@/utils/common-utils";
import { ethers } from "ethers";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

const PurchaseForm = ({ data, userWallet }) => {
    const router = useRouter();
    const appContext = useContext(AppContext);
    const poolContext = useContext(PoolContext);
    const messageContext = useContext(MessageContext);

    const apolloClient = initializeApollo();

    const { openPopup, closePopup, updatePopupData } = messageContext;

    const { saleContract: dataFromContract, saleEvent, updateSale } = poolContext;
    const { user, blockchain, initAlloction } = appContext;

    const { seedContract, payableContract } = blockchain;

    const [state, setState] = useState({
        approveBtn: data.approveBtn,
        purchaseBtn: data.purchaseBtn,
    });

    const [isAcceptedBusd, setAcceptedBusd] = useState(false);
    const [hasApproved, setApproved] = useState(undefined);

    useEffect(() => {}, []);
    useEffect(() => {
        if (payableContract) {
            payableContract.off("Approval");
            payableContract.on("Approval", (owner, spender, amount) => {
                console.log("Event_Approval", { owner, spender, amount });
            });
        }
    }, [payableContract]);

    useEffect(() => {
        return () => {
            if (payableContract) {
                payableContract.off("Approval");
            }
        };
    });

    useEffect(() => {
        if (!router.isReady) return;
        const commonConfig = JSON.parse(process.env.COMMON_CONFIG);
        let isTestBusd;
        if (router?.query?.busd) {
            isTestBusd = router?.query?.busd == "true";
        } else {
            isTestBusd = commonConfig?.busd ?? false;
        }

        setAcceptedBusd(isTestBusd);
        console.log({ payableContract });

        if (!payableContract || !isTestBusd) {
            setState({
                isInit: true,
                approveBtn: {
                    display: false,
                    disable: true,
                },
                purchaseBtn: {
                    display: true,
                    disable: false,
                },
            });
        } else {
            setState({
                ...state,
                isInit: true,
            });
        }
    }, [appContext.blockchain, router.isReady]);

    useEffect(() => {
        // Check allowance for seed contract
        if (payableContract) {
            // check allowance
            getAllowance();
        }
    }, [isAcceptedBusd]);

    useEffect(() => {
        if (state.isInit && hasApproved != undefined && dataFromContract) {
            validateBalance();
        }
    }, [dataFromContract, hasApproved]);

    useEffect(() => {
        if (state.isInit) {
            validateBalance();
        }
    }, [userWallet]);

    console.log("PurchaseForm", {
        data,
        dataFromContract,
        poolContext,
        appContext,
        userWallet,
    });

    const validateBalance = () => {
        console.log("validateBalance", { hasApproved });
        if (dataFromContract && userWallet) {
            let canPurchased =
                parseFloat(dataFromContract?.salePrice) <= parseFloat(userWallet.balance);
            console.log("validateBalance", { hasApproved, canPurchased });
            setState({
                approveBtn: {
                    ...state.approveBtn,
                    display: !hasApproved,
                    disable: !canPurchased,
                },
                purchaseBtn: {
                    ...state.purchaseBtn,
                    display: hasApproved,
                    disable: !canPurchased,
                },
            });
        }
    };

    // TODO: Can't confirm BE result
    const submitPurchaseResult = async () => {
        try {
            const resp = await apolloClient.mutate({
                mutation: BUY_SEED_MUTATION,
                variables: {
                    customerId: user.userId,
                    customerAddress: user.ether.address,
                    poolEventId: saleEvent.saleId,
                    isPurchased: true,
                    buyAmount: dataFromContract?.salePrice,
                    id: "",
                },
                notifyOnNetworkStatusChange: true,
            });
            console.log("submitPurchaseResult", resp);
            return true;
        } catch (error) {
            console.log("submitPurchaseResult_error", error);
        }
        return false;
    };

    const doPurchase = () => {
        const txOptions =
            payableContract && isAcceptedBusd
                ? {}
                : { value: ethers.utils.parseEther(dataFromContract?.salePrice) };

        console.log("doPurchase", { txOptions });
        seedContract
            .buySeed(txOptions)
            .then((result) => {
                console.log(result);
                // show popup
                openPopup({
                    isLoading: true,
                    messageData: popupLayoutConfig.purchaseSuccess,
                    closeCallback: closePopup,
                    okCallback: () => {
                        const blockExplorerURL = process.env.BLOCK_EXPLORER_URL;
                        window.open(blockExplorerURL + "tx/" + result.hash, "_blank").focus();
                    },
                });

                result.wait().then((receipt) => {
                    console.log("doPurchase", receipt);
                    const allocation = getAllocationInfo({
                        txid: result?.hash,
                        saleId: saleEvent.saleId,
                        title: saleEvent.title,
                        tokenPrice: saleEvent.tokenPrice,
                        salePrice: dataFromContract?.salePrice,
                        estReceiveMDN: dataFromContract?.estReceiveMDN,
                    });

                    updatePopupData({ isLoading: false });

                    // Update user info: purchased
                    submitPurchaseResult();

                    // update to
                    initAlloction({ allocations: [allocation] });

                    // Update sale date from pool-state
                    updateSale({
                        currentTimelineStep: Timeline.STEP_PURCHASE_SUCCESS,
                        layoutContentDef: {
                            tokenSaleHero: tokenSaleConfig.tokenPurchaseSuccess.tokenSaleHero,
                        },
                    });
                });
            })

            .catch((err) => {
                console.log("_error", err);
                let bscScanBtn;
                if (err.hash) {
                    bscScanBtn = popupLayoutConfig.commonFailure.bscScanBtn;
                }

                let errorMsg = err.message;
                if (err?.data) {
                    errorMsg = err?.data?.message;
                }

                // show popup
                openPopup({
                    messageData: {
                        ...popupLayoutConfig.commonFailure,
                        msg: errorMsg,
                        bscScanBtn,
                    },
                    closeCallback: closePopup,
                    okCallback: () => {
                        const blockExplorerURL = process.env.BLOCK_EXPLORER_URL;
                        if (err.hash) {
                            window.open(blockExplorerURL + "tx/" + err.hash, "_blank").focus();
                        }
                    },
                });
            });
    };

    const getAllowance = () => {
        console.log("getAllowance");
        if (payableContract && isAcceptedBusd) {
            payableContract
                .allowance(user.ether.address, seedContract.address)
                .then((result) => {
                    console.log("getAllowance", result);
                    const allowance = ethers.utils.formatEther(result);
                    console.log("getAllowance", {
                        allowance,
                        hasApproved: allowance >= dataFromContract?.salePrice,
                    });

                    setApproved(allowance >= dataFromContract?.salePrice);
                })
                .catch((err) => {
                    console.log("getAllowance_error", err);
                });
        }
    };

    const approveSmartContract = () => {
        if (payableContract && isAcceptedBusd) {
            payableContract
                .approve(
                    seedContract.address,
                    ethers.utils.parseEther(dataFromContract?.salePrice)
                )
                .then((result) => {
                    console.log("approveSmartContract", result);

                    // show popup
                    openPopup({
                        isLoading: true,
                        messageData: popupLayoutConfig.approveSuccess,
                        closeCallback: closePopup,
                        okCallback: () => {
                            const blockExplorerURL = process.env.BLOCK_EXPLORER_URL;
                            window
                                .open(blockExplorerURL + "tx/" + result.hash, "_blank")
                                .focus();
                        },
                    });

                    result.wait().then((receipt) => {
                        console.log(receipt);
                        updatePopupData({ isLoading: false });
                        setState({
                            approveBtn: {
                                display: false,
                                disable: true,
                            },
                            purchaseBtn: {
                                display: true,
                                disable: false,
                            },
                        });
                    });
                })
                .catch((err) => {
                    console.log("_error", err);
                });
        }
    };

    const renderApproveBtn = () => {
        if (state.approveBtn && state.approveBtn.display) {
            return (
                <CustomButton
                    disable={state.approveBtn.disable}
                    label={data.approveBtn.label}
                    handleClick={approveSmartContract}
                />
            );
        }
    };

    const renderPurchaseBtn = () => {
        if (state.purchaseBtn && state.purchaseBtn.display) {
            return (
                <CustomButton
                    disable={state.purchaseBtn.disable}
                    label={data.purchaseBtn.label}
                    handleClick={doPurchase}
                />
            );
        }
    };
    if (data) {
        return (
            <div className="flex flex-col backdrop-fitler backdrop-blur-lg bg-purchaseForm rounded-2xl font-secondary text-primary px-[5%] md:px-[3%] py-[5%] md:py-[3%] space-y-5 w-4/5">
                <div className="space-y-4 md:space-y-2">
                    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between font-primary whitespace-nowrap space-y-2 md:space-y-0 md:space-x-5 w-full md:w-[35%] xl:w-[40%]">
                        <div className="flex items-center justify-center">
                            <span className="hidden md:block uppercase text-primary text-xs md:text-sm lg:text-lg">
                                Wallet
                            </span>
                            <span className="block md:hidden uppercase text-primary text-xs md:text-sm lg:text-lg">
                                Wallet Balance
                            </span>
                        </div>
                        <div className="flex items-start justify-start">
                            <span className="font-secondary text-xs md:text-sm lg:text-sm text-primary/[.38]">
                                {`(Balance: ${formatBalance(userWallet.balance).toLocaleString(
                                    "en"
                                )} ${userWallet.currency}`}
                                )
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col items-center md:flex-row md:space-x-3 space-y-1 md:space-y-0">
                        <div className="flex flex-row justify-between text-primary font-primary font-bold rounded-lg ring-2 ring-white px-1 py-1 md:py-2 divide-x divide-white w-full md:w-[35%] xl:w-[40%] shrink-0">
                            <div className="flex flex-row justify-center md:justify-start items-center md:px-2 w-[50%] md:w-auto shrink-0 md:shrink-1">
                                <span className="text-md md:text-sm lg:text-lg">
                                    {parseFloat(dataFromContract?.salePrice).toLocaleString(
                                        "en"
                                    )}
                                </span>
                            </div>
                            <div className="flex flex-row justify-center md:justify-start items-center md:px-3 w-[50%] md:w-auto shrink-0 md:shrink-1">
                                <span className="text-md md:text-sm lg:text-lg">
                                    {saleEvent.acceptedCurrency}
                                </span>
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row items-center justify-center md:space-x-2 lg:space-x-2 space-y-2 md:space-y-0 whitespace-nowrap">
                            <div className="rotate-90 md:rotate-0 pl-4 md:pl-0">
                                <svg
                                    className="w-[15px] h-[15px]"
                                    viewBox="0 0 15 15"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="m11.422 9.289-8.528 4.264A2 2 0 0 1 0 11.763V3.237a2 2 0 0 1 2.894-1.789l8.528 4.264a2 2 0 0 1 0 3.578z"
                                        fill="#F4C25B"
                                        fillRule="evenodd"
                                    />
                                </svg>
                            </div>
                            <div>
                                <span className="text-xs lg:text-lg">
                                    {data.estimatedReceiveMDN.title}
                                </span>
                            </div>
                            <div className="flex items-center justify-center rounded-lg font-primary font-bold ring-2 ring-white px-2 py-1 md:px-4 md:py-2">
                                <span className="text-sm md:text-md">
                                    {`${
                                        parseFloat(
                                            dataFromContract?.estReceiveMDN | 0
                                        ).toLocaleString("en") ?? ""
                                    } ${data.estimatedReceiveMDN.currency}`}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="lg:pt-5 text-center">
                        <span className="text-sm md:text-md lg:text-lg text-primary/[.38]">
                            {state.approveBtn.display
                                ? data.approveBtn.remindDesc
                                : data.purchaseBtn.remindDesc}
                        </span>
                    </div>
                </div>
                <div className="flex flex-row items-center justify-center w-full pt-3 space-x-3 md:space-x-5">
                    {renderApproveBtn()}
                    {renderPurchaseBtn()}
                </div>
            </div>
        );
    }
    return null;
};

export default PurchaseForm;
